<template>
    <div class="c-header">
        <div class="c-header__wrap">
            <div class="c-header__logo">
                <a href="/">
                    <img src="@/assets/4marki.svg" alt="Jaguar Land Rover serwis Inchcape">
                </a>
            </div>
            <div class="c-header__title">
                <h1>Serwis Jaguar i Land Rover Inchcape Park.</h1>
                <h3>Umów serwis online</h3>
            </div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>
<style lang="scss">
@import '../_variables.scss';

.c-header {
    &__wrap {
        max-width: 1680px;
        margin: 0 auto;
        padding: 0 1rem .5rem 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        @media (max-width: 1440px) {
            max-width: 1124px;
        }

        @media (max-width: 780px) {
            display: block;
            padding-bottom: 1rem;
        }
    }

    &__logo {
        img {
            width: 640px;
            max-width: 90vw;
            margin: 0 1rem;
        }
    }

    &__title {
        h1 {
            font-size: 2rem;
            margin: 0;
            padding: 0;
        }

        h3 {
            margin: 0;
            padding: 0;
            color: $darkGray;
            font-size: 1rem;
            font-weight: 100;
        }

        @media (max-width:1280px) {
            h1 {
                font-size: 1.2rem;
            }
        }

        @media (max-width:780px) {
            h1 {
                font-size: .9rem;
            }

            h3 {
                font-size: .8rem;
            }
        }
    }
}
</style>